import { render, staticRenderFns } from "./CreateNewCard.vue?vue&type=template&id=636df93e"
import script from "./CreateNewCard.vue?vue&type=script&lang=js"
export * from "./CreateNewCard.vue?vue&type=script&lang=js"
import style0 from "./CreateNewCard.vue?vue&type=style&index=0&id=636df93e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports